module.exports = __webpack_public_path__ + "static/media/distributiveAnd1.2a341280.JPG";